// Put your application javascript here
const store = Vue.reactive({
  state: {
    products: [],
    selected: [],
  },

  getProducts() {
    console.log("loading products...");
    axios
      .get(
        `/collections/heart-healthy-retail?view=custom-collection-json`
      )
      .then((res) => {
        console.log(res);
        if (res.data && res.data.products) {
          this.state.products = res.data.products;
          console.log(`Products loaded!`);
        }
      });
  },
});

if (document.querySelector("#meals-checkout-app")) {
  const app = Vue.createApp({
    template: /*html*/ `

    <div class="flex flex-col lg:flex-row w-full"  v-if="currentTab == 'Meals'">
  <div class="w-full">
    <div class="bg-[#deedbf] min-h-[3rem]  z-[1029] flex items-center justify-center"
      style="border-bottom: 1px solid #dee2e6">
      <ol class="flex w-full justify-center gap-4">
        <li>
          <a href="#" class="text-[1.125rem] leading-[1.125rem] tracking-normal font-extrabold">Meals</a>
        </li>
        <li> 
          <a href="#" class="text-[#666] text-[1.125rem] leading-[1.125rem] tracking-normal font-medium"
           >Checkout</a>
        </li>
      </ol>
    </div>
    <div>  
          <div class="fixed inset-0 transition-opacity  duration-500 z-50 ease-in-out bg-gray-500 bg-opacity-75 opacity-0 opacity-100 cursor-pointer dull-bg md:duration-300"
          :class="{'hidden': !slideCartOpen,'block': slideCartOpen,}" @click="closeSlideCart">
          </div>
          <div class="cartwrapper-3 h-screen  fixed   !top-[0px] !right-0 z-50   bg-white transition duration-500 md:duration-300 ease-in-out transform  pointer-events-auto"
          id="cartWrapper" :class="{'translate-x-[700px]': !slideCartOpen, 'translate-x-[0px]': slideCartOpen, }">
          <div class="max-w-[380px] mx-auto bg-white p-4">
          <div class="w-full h-[56px] flex justify-between items-center ">
        <h2 class="uppercase text-black !font-[futura-pt-bold,sans-serif] font-semibold text-[18px] leading-[26px] tracking-[0.4px]" id="slide-over-title">
          Meal Preferences
        </h2>
        <div class="flex items-center ml-3 h-7">
          <button type="button" class="text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 filter-close-btn" @click="closeSlideCart" >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.6 0L0 1.6L6.4 8L0 14.4L1.6 16L8 9.6L14.4 16L16 14.4L9.6 8L16 1.6L14.4 0L8 6.4L1.6 0Z" fill="black"></path>
            </svg>
          </button>
        </div>
      </div>
          <div class="!grid grid-cols-3  gap-3  !ml-0">
          <label 
          v-for="(option, index) in sortedMealOptions" 
          :key="index" 
          :class="[
          'flex', 
          'items-center', 
          'border border-[#E9E9E9]', 
          'justify-center',  
          '!py-1 p-1', 
          'text-black', 
          'font-semibold', 
          'uppercase', 
          'sm:flex-1', 
          '!mb-0', 
          'min-h-[45px]', 
          'focus:outline-none', 
          {'text-white': option.checked, 
          'hover:bg-[#005874]  cursor-pointer hover:text-white' : option.count>0,
          'cursor-not-allowed !bg-gray-100' : option.count==0, 
          '!bg-[#005874]': option.checked }]">
          <input type="checkbox" :name="'meal-option'" :value="option.value" class="sr-only" :aria-labelledby="'meal-option-' + index + '-label'" 
                    v-model="option.checked"
          :disabled="option.count==0">
          <span  :id="'meal-option-' + index + '-label'" class="text-[12px] ">{{ option.label }} </span>
          <span  class="text-[12px]  p-1">{{option.count }}</span>
          </label>
          
          </div>
          </div>
          
          <div class="sticky !bottom-0 px-4 pb-3 bg-white sm:px-6" @click="closeSlideCart"><div class="gap-4 pt-1 "><a target="_self" class="block w-full" rel="noreferrer noopener"><button class="flex items-center justify-center w-full px-6 py-3 text-base font-bold text-white border border-transparent rounded-md shadow-sm bg-[#005874]  font-avant"><!----><span> Close </span></button></a></div></div>
          </div>
          </div>
          <div class="border-b border-t my-3 md:my-5   py-3 md:py-5  " >  
          <div class="flex gap-2 justify-between px-2 md:px-4">
          <h2 class="uppercase text-black my-auto !font-[futura-pt-bold,sans-serif] font-semibold text-[17px] md:text-[20px] leading-[26px] tracking-[0.4px]" id="slide-over-title">
          Meal Preferences
        </h2>
        <div class=" lg:block hidden my-auto ">
       <div class="flex flex-wrap gap-2">
    <div class="my-auto" v-for="option in checkedOptions" :key="option.id">
     <div class="flex gap-2  my-auto whitespace-nowrap justify-center rounded-md hover:bg-gray-200 bg-gray-100 border  py-1 px-1 cursor-pointer ">
      <span class="text-[12px]">
        {{ option.label }}
      </span>
      <span @click="toggleOption(option)" class="my-auto"><svg width="5" height="5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.6 0L0 1.6L6.4 8L0 14.4L1.6 16L8 9.6L14.4 16L16 14.4L9.6 8L16 1.6L14.4 0L8 6.4L1.6 0Z" fill="black"></path>
            </svg></span></div>
    </div>
  </div></div>
           <div class="w-[180px] my-auto  h-[40px] border-2 border-[#E9E9E9] text-black !font-[futura-pt,sans-serif] !font-[600] !text-[14px] !leading-[18px] !tracking-[0.84px] flex justify-center items-center cursor-pointer filter-open-btn" @click="openSlideCart">
          FILTER <span class="tag-filter-count" v-if="checkedCount">&nbsp;({{checkedCount}})</span>
          </div></div>
            <div class=" lg:hidden block my-3">
       <div class="flex flex-wrap px-4 gap-2 justify-center">
    <div class="my-auto" v-for="option in checkedOptions" :key="option.id">
     <div class="flex gap-2  my-auto whitespace-nowrap justify-center rounded-md hover:bg-gray-200 bg-gray-100 border  py-1 px-1 cursor-pointer ">
      <span class="text-[12px]">
        {{ option.label }}
      </span>
      <span @click="toggleOption(option)" class="my-auto"><svg width="5" height="5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.6 0L0 1.6L6.4 8L0 14.4L1.6 16L8 9.6L14.4 16L16 14.4L9.6 8L16 1.6L14.4 0L8 6.4L1.6 0Z" fill="black"></path>
            </svg></span></div>
    </div>
  </div></div>
          </div>
          <div v-if="productNotFound" class="text-xl mt-6 md:mt-20 font-semibold text-center" >
            Products not found
            </div>
          <div class="p-4">
      <div class="!grid lg:grid-cols-4 gap-4 !m-0">
        <div v-for="item in filteredProducts" :key="item.id">
          <div  class="flex lg:flex-col group cursor-pointer" style="background-color: #fff;border: 0;box-shadow: 0 1px #d0dede;">
              <div class="min-w-[130px] portrait:max-w-[30%] min-h-[160px] lg:w-full lg:h-[190px] object-cover relative">
              <img @click="selectedModal = item.id" :src="item.featured_image" class="min-w-[130px] portrait:max-w-[30%] min-h-[160px] lg:w-full lg:h-[190px] object-cover" />
              <div class="absolute  bottom-0 flex items-center justify-center left-0 bg-[#f7fc54] text-[.75rem] font-bold p-1"  
              v-if="getTypeTagIfAvailable(item)"
              v-html="getTypeTagIfAvailable(item)"
              >
              </div>
              </div>
              <div class="p-4 group-hover:bg-[#deedbf]">
                <div class="text-[#fe6c2f] text-[.875rem] leading-[1rem]">
                  {{ item.vendor }} 
                </div>
                <div class="hidden"  :class="{'!block' : item.selling_plan_groups?.[0]?.selling_plans?.length==0}" > 
                {{item.selling_plan_groups?.[0]?.selling_plans?.length}}
                </div>
                <p class="text-[1.2rem] leading-[1.25rem] mb-2" 
                @click="selectedModal = item.id"
                >
                {{item.title}} 
                </p>
                <div class="flex justify-end"
                :class="{'pointer-events-none opacity-20': item.selling_plan_groups?.[0]?.selling_plans?.length==0 }">
                  <div class="AddButton hover:bg-[#fd6d2e]" role="button" @click="addProduct(item)">
                    <div class="inline-flex items-center">
                      <svg class="mr-[.3rem]" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-8 -8 16 16"
                        width="16" height="16" style="transform: translate3d(0px, 0px, 0px)">
                        <g class="">
                          <path d=" M1,-8 C1,-8 1,8 1,8 C1,8 -1,8 -1,8 C-1,8 -1,-8 -1,-8 C-1,-8 1,-8 1,-8z"></path>
                          <path d=" M8,-1 C8,-1 8,1 8,1 C8,1 -8,1 -8,1 C-8,1 -8,-1 -8,-1 C-8,-1 8,-1 8,-1z"></path>
                        </g>
                      </svg>
                      <span class="">Add</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="selectedModal == item.id">
              <div
                @click="selectedModal = -1"
                class="fixed inset-0 bg-black/30 z-[99]"
              ></div>
              <div
                class="fixed inset-0 flex items-center justify-center p-[15px] z-[100]"
              >
                <div hyyy class="max-w-[1100px] w-full max-h-[800px] mx-auto my-auto bg-white">
                  <div class="p-[15px] border-[#d3d3d3] border-b flex items-center justify-between">
                    <span>{{item.title}}</span>
                    <div class="flex gap-[15px] items-center justify-end">
                      <div class="AddButton hover:bg-[#fd6d2e]" role="button" @click="addProduct(item); selectedModal = -1">
                        <div class="inline-flex items-center">
                          <svg class="mr-[.3rem]" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-8 -8 16 16"
                            width="16" height="16" style="transform: translate3d(0px, 0px, 0px)">
                            <g class="">
                              <path d=" M1,-8 C1,-8 1,8 1,8 C1,8 -1,8 -1,8 C-1,8 -1,-8 -1,-8 C-1,-8 1,-8 1,-8z"></path>
                              <path d=" M8,-1 C8,-1 8,1 8,1 C8,1 -8,1 -8,1 C-8,1 -8,-1 -8,-1 C-8,-1 8,-1 8,-1z"></path>
                            </g>
                          </svg>
                          <span class="">Add</span>
                        </div>
                      </div>

                      <span @click="selectedModal = -1" style="cursor: pointer; padding: 10px; border: 1px solid rgb(94, 94, 94); font-size: 18px; line-height: 1; color: black;">⤫</span>
                    </div>
                  </div>

                    <div class="flex justify-center">
                        <div class="modal-content-left w-[50%] p-[15px]">
                            <img
                              v-for="image in item.images"
                              :src="image" />
                        </div>
                        <div class="modal-content-right w-[50%] p-[21px] max-h-[560px] overflow-y-scroll bg-white mt-[5px]" v-html="item.description">
                            
                        </div>


                    </div>
                  
                </div>
              </div>
            </div>

        </div>
      
      </div>

      <div class="lg:hidden">
        <div class="fixed bottom-8 right-8 bg-[#f2f2f2] p-4 rounded-full shadow-lg z-[999]" @click="showSummary = true">

          <p class="absolute px-3">{{ totalQuantity }}</p>

          <svg xmlns="http://www.w3.org/2000/svg" width="31" height="25" viewBox="0 0 31 25"
          class="">
            <g fill="none" transform="translate(.593)">
              <circle cx="20.5" cy="22.5" r="2" stroke="#333"></circle>
              <circle cx="10.5" cy="22.5" r="2" stroke="#333"></circle>
              <path fill="#333"
                d="M3.333 5.5c.56 0 1.068.31 1.326.798l.059.125 4.23 10.154c.216.516.698.866 1.247.917l.138.006h10.293a1.5 1.5 0 0 0 1.343-.831l.057-.13.976-2.539h1.071l-1.113 2.897a2.498 2.498 0 0 1-2.152 1.596l-.182.007H10.333c-.95 0-1.812-.538-2.234-1.377l-.073-.161L3.795 6.808a.498.498 0 0 0-.377-.3L3.333 6.5H0v-1h3.333zM29.458 0l-4.615 12h-1.072l4.616-12h1.071z">
              </path>
            </g>
          </svg>
        </div>

      </div>

      <div v-if="showSummary">
        <div
          class="fixed inset-0 bg-black/30 z-[99]"
        ></div>
        <div
          class="fixed inset-0 flex items-center justify-center p-[15px] z-[100]"
        >
          <div class="max-w-[400px] max-h-[650px] mx-auto my-auto bg-white">
            <div class="p-[15px] border-[#d3d3d3] border-b flex items-center justify-between">
              <span>Summary</span>
              <div class="flex gap-[15px] items-center justify-end">
              <span @click="showSummary = false" style="cursor: pointer; padding: 10px; border: 1px solid rgb(94, 94, 94); font-size: 18px; line-height: 1; color: black;">⤫</span>
              </div> 
            </div>

                <div>
                 <div class="flex justify-center py-3">
                 <label class="m-0 px-4"> Your delivery frequency </label>
                 <select class="border-0 font-bold px-2 underline "
                         v-model="delivery_type"
                         


                 >   
                <option value="1"    > Every Week</option>
                <option value="2" > Every Other Week</option>
                <option value="4"   > Every Month</option> 
                
                 </select>
                 </div> 
                <div>
                    <div v-if="totalQuantity == total" role="button" class="CartFooter-btn" @click="proceedNext()" :disabled="cartProcessing || totalQuantity < total">
                      <span v-if="cartProcessing">Loading...</span>
                      <span v-if="!cartProcessing">NEXT -</span>
                    </div>
                    <div class="CartFooter-noticeText" v-if="totalQuantity == total">
                      <span class="flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                          viewBox="0 0 16 16">
                          <path fill="#07872B"
                            d="M13.445 4.113c0 .533-.242 1.053-.725 1.559l-.075.075-4.225 4.45c-.897.944-1.662 1.673-2.293 2.188-.631.515-1.077.772-1.336.772-.274 0-.613-.129-1.019-.386-.406-.257-.668-.523-.786-.796-.1-.228-.195-.711-.284-1.45a20.136 20.136 0 0 1-.133-2.399c0-.47.196-.904.588-1.302.392-.399.825-.598 1.299-.598.45 0 .72.412.806 1.237l.02.212c.074.633.158 1.075.254 1.326.095.25.225.376.39.376.068 0 .195-.074.382-.222.187-.148.41-.35.67-.605l4.34-4.3a6.34 6.34 0 0 1 .978-.827c.287-.187.531-.28.732-.28.15 0 .257.057.321.17.064.114.096.306.096.575v.225z">
                          </path>
                        </svg>All Set!</span>
                    </div>
                  </div>

                

                  <div class="overflow-y-scroll max-h-[500px] px-[.5rem]">
 
                      <div 
                      v-for="(item, i) in selected"
                      class="flex flex-col lg:flex-row items-center justify-between bg-white my-[.5rem] min-w-[300px] w-full relative group-hover:bg-[#faf9f8] "
                      style="border: 1px solid #f2f2f2;box-shadow: 0 1px #ededed;">
                      <figure class="flex items-center w-full m-0">
                        <img :src="item.featured_image" class="inline-block w-[64px] h-[64px] m-[1rem] "
                          style="-webkit-filter: drop-shadow(-3px 3px 8px rgba(0,0,0,.2)) drop-shadow(0 0 4px rgba(0,0,0,.2));filter: drop-shadow(-3px 3px 8px rgba(0,0,0,.2)) drop-shadow(0 0 4px rgba(0,0,0,.2));" />
                        <div class="flex flex-col flex-1">
                          <h2 class="uppercase m-0"
                            style="font-weight: 500;font-size: .875rem;line-height: 1rem;letter-spacing: 1.4px;color: #333;">
                            {{ item.title }}
                          </h2>
                        </div>
                      </figure>
                      <div class="flex flex-row-reverse lg:flex-col items-center">
                        <div role="button" class="inline-block w-[48px] h-[48px] p-[1rem] bg-transparent hover:bg-[#faf9f8]"
                          @click="addProduct(item)">
                          <div class="CartItem-btn add"
                            style="font-weight: 400;font-size: 30px;line-height: 1rem;letter-spacing: normal;color: #01596e;">
                          </div>
                        </div>
                        <p>{{ item.quantity }}</p>
                        <div role="button" class="inline-block w-[48px] h-[48px] p-[1rem] bg-transparent hover:bg-[#faf9f8]"
                          @click="removeProduct(item)">
                          <div class="CartItem-btn remove"
                            style="font-weight: 400;font-size: 30px;line-height: 1rem;letter-spacing: normal;color: #666;"></div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
            
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="w-[344px] min-w-[344px] flex flex-col lg:h-screen lg:sticky lg:top-0" style="border-left: 1px solid #d9d9d9;">
    <div class="flex justify-between h-[48px] items-center px-[1rem] bg-[#faf9f8] sticky top-0"
      style="border: 0.5px solid #f2f2f2;">
      <p style="font-weight: 400;font-size: .875rem;line-height: 1rem;letter-spacing: normal;color: #333;"> Estimated Delivery Date<br/>
        <b>{{ formattedDate(showingDeliveryDate) }}</b></p>
      <div class="clear-all-button" @click="selected = []">Clear All</div>
    </div>

    <div class="lg:max-h-[600px] relative flex lg:flex-grow lg:overflow-scroll mb-[30px] lg:mb-0">
      <ul class="pt-[4px] flex lg:block mb-[7px] w-[100vw] lg:w-full overflow-x-scroll">
        <li v-for="(item, i) in selected" class="mb-[0.25em] group">
          <div
            class="flex justify-between bg-white my-[.5rem] mx-[1rem] min-w-[300px] w-[300px] lg:w-[calc(100% - 2rem)] relative group-hover:bg-[#faf9f8]"
            style="border: 1px solid #f2f2f2;box-shadow: 0 1px #ededed;">
            <figure class="flex items-center w-full m-0">
              <img :src="item.featured_image" class="inline-block w-[64px] h-[64px] m-[1rem] "
                style="-webkit-filter: drop-shadow(-3px 3px 8px rgba(0,0,0,.2)) drop-shadow(0 0 4px rgba(0,0,0,.2));filter: drop-shadow(-3px 3px 8px rgba(0,0,0,.2)) drop-shadow(0 0 4px rgba(0,0,0,.2));" />
              <div class="flex flex-col flex-1">
                <h2 class="uppercase m-0"
                  style="font-weight: 500;font-size: .875rem;line-height: 1rem;letter-spacing: 1.4px;color: #333;">
                  {{ item.title }}
                </h2>
              </div>
            </figure>
            <div class="hidden lg:flex lg:flex-col lg:items-center">
              <div role="button" class="inline-block w-[48px] h-[48px] p-[1rem] bg-transparent hover:bg-[#faf9f8]"
                @click="addProduct(item)">
                <div class="CartItem-btn add"
                  style="font-weight: 400;font-size: 30px;line-height: 1rem;letter-spacing: normal;color: #01596e;">
                </div>
              </div>

              <p>{{ item.quantity }}</p>

              <div role="button" class="inline-block w-[48px] h-[48px] p-[1rem] bg-transparent hover:bg-[#faf9f8]"
                @click="removeProduct(item)">
                <div class="CartItem-btn remove"
                  style="font-weight: 400;font-size: 30px;line-height: 1rem;letter-spacing: normal;color: #666;"></div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div role="button" class="pb-[15px] relative pt-[24px] px-[16px] bg-[#faf9f8]" style="">
      <div class="absolute top-0 left-[50%] " style="transform: translate(-50%,-50%);">
        <div
          style="position: absolute;width: 72px;height: 24px;pointer-events: none;border: 1px solid #f2f2f2;border-bottom: none;border-top-left-radius: 24px;border-top-right-radius: 24px;">
        </div>
        <button class="mb-[30px] flex w-[72px] h-[48px] py-[10px] px-[5px] bg-[#faf9f8]"
          style="font-size: .875rem;border: none;border-radius: 0;outline: none;">
          <section style="position: relative;bottom: 4px;left: 18px;width: 15px;color: #01596e;">
            <aside class="flex flex-col" style="transform: translateY(-50%);">
              <span style="opacity: 0;">{{ totalQuantity }}</span>
              <span style="opacity: 1;">{{ totalQuantity }}</span>
            </aside>
          </section>
          <svg xmlns="http://www.w3.org/2000/svg" width="31" height="25" viewBox="0 0 31 25"
            class="absolute left-[15px]">
            <g fill="none" transform="translate(.593)">
              <circle cx="20.5" cy="22.5" r="2" stroke="#333"></circle>
              <circle cx="10.5" cy="22.5" r="2" stroke="#333"></circle>
              <path fill="#333"
                d="M3.333 5.5c.56 0 1.068.31 1.326.798l.059.125 4.23 10.154c.216.516.698.866 1.247.917l.138.006h10.293a1.5 1.5 0 0 0 1.343-.831l.057-.13.976-2.539h1.071l-1.113 2.897a2.498 2.498 0 0 1-2.152 1.596l-.182.007H10.333c-.95 0-1.812-.538-2.234-1.377l-.073-.161L3.795 6.808a.498.498 0 0 0-.377-.3L3.333 6.5H0v-1h3.333zM29.458 0l-4.615 12h-1.072l4.616-12h1.071z">
              </path>
            </g>
          </svg>
          <p class="relative bottom-[3px] left-[27px] text-[12px] text-[#333]">{{ total }}</p>
          <div class="absolute bottom-0 left-[28px] w-[16px] h-[1px] " style="border: 1px solid #f2f2f2;"></div>
        </button>
      </div>
      <div>
      <div
      
      class="flex justify-between py-3 w-full">
      <label class="m-0 pr-4">How many meals </label> 
      
          <select
            v-if="delivery_type=='one-time'"
         class="border-0 font-bold px-2 underline pr-[20px]"
                v-model="how_many_meals"  >
            <option value="10"    > 10 Meals - $150.00</option> 
          <option value="15"    > 15 Meals - $202.50</option>
        </select>     
        
         <select
          v-else
         class="border-0 font-bold px-2 underline pr-[20px]"
                v-model="how_many_meals"  >
         <option value="10"    > 10 Meals - $150.00</option> 
          <option value="15"    > 15 Meals - $202.50</option>
        </select>   
        

      



      </div>
      <div class="flex justify-between py-3 w-full">
      
        <label class="m-0 pr-4"> Deliver </label>
        <select class="border-0 font-bold px-2 underline pr-[20px] block"
                v-model="delivery_type"  >
          <option value="1"    > Every Week</option>
          <option value="2" > Every Other Week</option>
          <option value="4"   > Every Month</option> 
         
        </select> 
      
      </div>  
        <div role="button" class="CartFooter-btn" @click="proceedNext()" :disabled="cartProcessing || totalQuantity < total">
        <span v-if="cartProcessing">Loading...</span>
        <span v-if="!cartProcessing">NEXT</span>
        </div>
        <div class="CartFooter-noticeText" v-if="totalQuantity == total">
          <span class="flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
              viewBox="0 0 16 16">
              <path fill="#07872B"
                d="M13.445 4.113c0 .533-.242 1.053-.725 1.559l-.075.075-4.225 4.45c-.897.944-1.662 1.673-2.293 2.188-.631.515-1.077.772-1.336.772-.274 0-.613-.129-1.019-.386-.406-.257-.668-.523-.786-.796-.1-.228-.195-.711-.284-1.45a20.136 20.136 0 0 1-.133-2.399c0-.47.196-.904.588-1.302.392-.399.825-.598 1.299-.598.45 0 .72.412.806 1.237l.02.212c.074.633.158 1.075.254 1.326.095.25.225.376.39.376.068 0 .195-.074.382-.222.187-.148.41-.35.67-.605l4.34-4.3a6.34 6.34 0 0 1 .978-.827c.287-.187.531-.28.732-.28.15 0 .257.057.321.17.064.114.096.306.096.575v.225z">
              </path>
            </svg>All Set!</span>
        </div>
      </div>
    </div>
  </div>
  <div></div>
</div>
<div v-if="currentTab == 'Checkout'">
  <div class="bg-[#deedbf] min-h-[3rem] sticky top-0 z-[1029] flex items-center justify-center"
    style="border-bottom: 1px solid #dee2e6">
    <ol class="flex w-full justify-center gap-4">
      <li>
        <a href="#" class="text-[#666] text-[1.125rem] leading-[1.125rem] tracking-normal  font-extrabold"
          @click="currentTab = 'Meals'">Meals</a>
      </li>
      <li>
        <a href="#" class="text-[#666] text-[1.125rem] leading-[1.125rem] tracking-normal font-extrabold">Checkout</a>
      </li>
    </ol>
  </div>

  <div>
    <div>
      <div class="cart__page" style="padding: 20px;">
        <div class="cart__page-col">
          <div class="cart__item" data-key="32740376051797:0a249cfccdacd08fe88b69286edcfa59">
            <div class="cart__image"><a 
                style="height: 0px; padding-bottom: 100%;"><img class="lazyautosizes lazyloaded"
                  data-widths="[180, 360, 540]" data-aspectratio="true" data-sizes="auto"
                  
                  :src="customMainProductVariant?.featured_image?.src"
                  ></a>
            </div> 
            <div class="cart__item-details">
              <div class="cart__item-title"><a
                  
                  class="cart__item-name">Pick Your Own Plan </a>
                <div class="cart__item--variants"></div>
                
                <div class="meals-per-week">Meals Per Week:&nbsp;10</div>
                <div class="product_type">Product Type : <span class="product_type capitalize">{{product_type}}</span></div>        
                <div class="delivery-type">Delivery : <span class="delivery_type capitalize">{{delivery_type_text}}</span></div>        
                <div class="ship-date">Ship Date:&nbsp;{{ formattedDate(cartData?.attributes["Ship Date"]) }}</div>
              </div>
              <div class="cart__item-sub">
                <div>
                  <div class="js-qty__wrapper"><label
                      for="cart_updates_32740376051797:0a249cfccdacd08fe88b69286edcfa59-page"
                      class="hidden-label">Quantity</label><input type="text"
                      id="cart_updates_32740376051797:0a249cfccdacd08fe88b69286edcfa59-page" name="updates[]"
                      class="js-qty__num" value="1" min="0" pattern="[0-9]*"
                      data-id="32740376051797:0a249cfccdacd08fe88b69286edcfa59" disabled=""></div><br>
                </div>
                <div class="cart__item-price-col text-right"><span class="cart__price">{{ "$" }}{{ cartData.items_subtotal_price / 100 }}</span></div>
              </div>
            </div>
          </div>
          <div
            style="display: flex; justify-content: center; font-weight: 500;background-color: #faf9f8;padding: 15px;color: #333;">
            Your Selected Meals </div>
          <hr class="no-b">
          <div class="cart__item" v-for="item in selected" :key="item.id">
            <div class="cart__image"><a href="/products/copy-of-okinawa-shrimp-taco-rice-bowl-1?variant=32740376051797"
                style="height: 0px; padding-bottom: 100%;"><img class="lazyautosizes lazyloaded"
                  data-widths="[180, 360, 540]" data-aspectratio="true" data-sizes="auto"
                  alt="Nicoyan Tomatillo Salsa with N4L Rainbow Patty" :data-srcset="item.featured_image" sizes="150px"
                  :srcset="item.featured_image"></a>
            </div>
            <div class="cart__item-details">
              <div class="cart__item-title"><a
                  
                  class="cart__item-name">{{ item.title }}</a>
                <div class="cart__item--variants"></div>
               
              </div>
              <div class="cart__item-sub">
                <div>
                  <div class="js-qty__wrapper"><label class="hidden-label">Quantity</label><input type="text"
                      name="updates[]" class="js-qty__num" :value="item.quantity" min="0" pattern="[0-9]*" disabled=""></div><br>
                </div>
                <div class="cart__item-price-col text-right"><span class="cart__price">$0.00</span></div>
              </div>
            </div>
          </div>
 
            <hr class="no-b">
          <div v-if="show_olive_upsell">
           <div v-if="show_olive_upsell && !added_upsell" class="bg-white border border-gray-200 flex flex-col items-start md:flex-row rounded-lg shadow"><img class="md:h-auto object-cover w-[350px]" src="/cdn/shop/products/OliveOil_720x.png?v=1679339285" alt=""><div class="flex flex-col justify-between leading-normal p-4"><h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">2 x Organic Polyphenol Rich Olive Oil</h5><p class="mb-3 font-normal text-gray-700 dark:text-gray-400"><ul class="list-disc mt-5 pl-8"><li>Premium Extra Virgin Centenarian Olive Oil</li><li>From Bosana and Coratina Olive Cultivars in Sardinia Italy</li><li>Gently Cold Pressed and unfiltered to preserve superior polyphenol levels</li><li>250ml (8.5fl oz) Product of Italy</li><li>USDA Organic cert</li><li>Certified by control body authorized by Suolo e Salute</li></ul><p class="font-bold mt-3 text-3xl">
 <s class="text-gray-400">$45</s> $25 
</p>
    <button type="button" name="add" class="btn mt-5"
    @click.prevent="addUpsell(40733892378709, 2)"
    >
      
      <span v-if="adding_upsell">Adding...</span>
      <span v-else>Add to cart</span>
    </button></p></div> 
    </div>
    <div v-else class="cart__item"><div class="cart__image"><a style="height: 0px; padding-bottom: 100%;"><img  src="/cdn/shop/products/OliveOil_720x.png?v=1679339285" ></a></div>
    <div class="cart__item-details">
    <div class="cart__item-title"><a class="cart__item-name">Organic Polyphenol Rich Olive Oil</a>
    <div class="cart__item--variants"></div></div><div class="cart__item-sub"><div><div class="js-qty__wrapper" data-form-type="other"><label class="hidden-label">Quantity</label><input type="text" name="updates[]" class="js-qty__num" min="0" value="2" pattern="[0-9]*" disabled=""  data-form-type="other"></div><br></div><div class=""><span class="cart__price">$25</span></div></div></div></div>
     </div>
        </div> 
        <div class="cart__page-col white-background">
          <div class="delivery-row" style="display: none;"><b>Please select your ship date</b></div>
          <div data-discounts="true"></div>
          <div class="cart__item-sub cart__item-row">
            <div><b>Subtotal</b></div>
            <div data-subtotal="true"><b>{{ "$" }}{{ cartData.items_subtotal_price / 100 }}</b></div>
          </div>
           <div class="cart__item-sub cart__item-row">
            <div><b>Delivery</b></div>
            <div ><b>{{delivery_type_text}}</b></div>
          </div>
          <div class="cart__item-sub cart__item-row">
            <div class="w-full flex justify-between !m-0">
            <span>Your scheduled delivery date is:</span>
            <b> {{ formattedDateWithDay(showingDeliveryDate) }}</b>
            </div>
          </div>
          <div class="cart__item-row cart__checkout-wrapper" @click="checkout"><a name="checkout" class="btn cart__checkout"
              style="visibility: visible;">Check out</a></div>
          <div class="cart__item-row text-center"><small> <span style="font-size: 12px; line-height: 14px;"><i> Tax,
                  shipping, &amp; discounts applied in checkout.</i></span> </small>
                  
                  <small 
                  v-if="delivery_type != 'one-time'"
                  ><br> <b>SKIP, PAUSE
                OR CANCEL ANY TIME</b> <br><span style="font-size: smaller; color: rgb(49, 49, 49);">After
                completing this order, you will be notified via email each week to modify, skip, pause, or
                cancel your order before your cutoff. See our <a href="/pages/faqs" target="_blank">FAQs</a> for
                additional details. </span><br></small>
                
                </div>
        </div>
      </div>
    </div>

  </div>

</div>
    
    `,
    data() {
      return {
        slideCartOpen: false,
        selectedmeal: "Low Carb",
        mealOptions: [
          { label: "Vegan", value: "Vegan" },
          { label: "Chicken", value: "Chicken" },
          { label: "Turkey", value: "Turkey" },
          { label: "Vegetarian", value: "Vegetarian" },
          { label: "Fish", value: "Fish" },
          { label: "Beef", value: "Beef" },
          { label: "Shellfish", value: "Shellfish" },
        ],
        currentTab: "Meals",
        selected: store.state.selected,
        products: store.state.products,
        qParams: window.location.search,
        params: [],
        show_olive_upsell: false,
        adding_upsell: false,
        added_upsell: false,
        deliveryDate: null,
        showingDeliveryDate: null,
        cartProcessing: false,
        customData: null,
        oneTimeProduct: null,
        cartData: null,
        grouped: null,
        selectedModal: -1,
        showSummary: false,
        delivery_type: "1",
        how_many_meals: "10",
      };
    },
    methods: {
      toggleOption(option) {
        option.checked = false;
      },
      optioncheckednames() {
        return this.checkedOptions.map((option) => option.label).join(", ");
      },
      openSlideCart() {
        this.slideCartOpen = true;
      },
      closeSlideCart() {
        this.slideCartOpen = false;
      },
      getParemeterByName(name) {
        let url = window.location.search;
        let params = url.split("?")[1].split("&");
        let param = params.filter((p) => p.includes(name))[0];
        if (!param) return null;

        param = param.split("=")[1];
        //removehash
        return param;
      },
      async addUpsell(variantId, quantity) {
        this.adding_upsell = true;
        await this.addVariantToCart(variantId, quantity);
        this.adding_upsell = false;
        this.added_upsell = true;
        //this.show_olive_upsell = false;
        this.getCartData();
      },
      formattedDate(date) {
        let dateObj;
        if (typeof date === "string") {
          dateObj = new Date(date);
        } else {
          dateObj = date;
        }

        return moment(dateObj.toISOString().split("T")[0], "YYYY-MM-DD").format(
          "DD MMMM YYYY"
        );
      },
      formattedDateWithDay(date) {
        let dateObj;
        if (typeof date === "string") {
          dateObj = new Date(date);
        } else {
          dateObj = date;
        }

        return moment(dateObj.toISOString().split("T")[0], "YYYY-MM-DD").format(
          "dddd, DD MMMM YYYY"
        );
      },
      addProduct(item) {
        if (this.totalQuantity < this.total) {
          const existingItem = this.selected.find(
            (element) => element.id === item.id
          );

          if (existingItem) {
            // If the item exists, increase the quantity by one.
            existingItem.quantity++;
          } else {
            // If the item does not exist, add the item with quantity set to 1.
            this.selected.push({ ...item, quantity: 1 });
          }
        } else {
          this.showSummary = true;
        }
      },
      async addVariantToCart(variantId, quantity) {
        let properties = {
          shipping_interval_unit_type: "Weeks",
          shipping_interval_frequency: "1",
          charge_on_day_of_week: "4",
        };
        if (this.delivery_type == "2") {
          properties["shipping_interval_frequency"] = "2";
        } else if (this.delivery_type == "4") {
          properties["shipping_interval_frequency"] = "1";
          properties["shipping_interval_unit_type"] = "Months";
        }

        const props = {
          items: [
            {
              quantity: quantity,
              id: variantId,
              properties,
            },
          ],
        };

        const body = JSON.stringify(props);
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body,
        });
        const data = await response.json();

        return data;
      },
      removeProduct(item) {
        const selectedItem = this.selected.find(
          (element) => element.id === item.id
        );
        if (selectedItem) {
          // Ensure quantity is greater than 0 before decreasing.
          if (selectedItem.quantity > 1) {
            selectedItem.quantity--;
          } else {
            // Remove the item if its quantity is 0 or less.
            const index = this.selected.indexOf(selectedItem);
            if (index !== -1) {
              this.selected.splice(index, 1);
            }
          }
        }
      },
      findId() {
        let howManyMeals = this.getParemeterByName("how-many-meals");
        let price = this.getParemeterByName("price");
        let source = this.getParemeterByName("product_type");
        let variant = this.customMainProduct.variants.find((i) => {
          return i.option2.toLowerCase().includes(source);
        });

        console.log("==ID==", variant.id);

        return variant.id;
      },
      getCartData() {
        axios.get(`/cart.js`).then((res) => {
          this.cartData = res.data;
        });
      },
      async proceedNext() {
        try {
          let MAX_ALLOWED_SELECTION = this.total;

          if (this.totalQuantity != this.total) {
            alert(`Please select all ${this.total} items to continue.`);
            return;
          }

          this.cartProcessing = true;
          let properties = {
            //shipping_interval_unit_type: "Weeks",
            //  shipping_interval_frequency: "1",
            charge_on_day_of_week: "4",
          };
          if (this.delivery_type == "bi-weekly") {
            // properties["shipping_interval_frequency"] = "2";
          } else if (this.delivery_type == "monthly") {
            // properties["shipping_interval_frequency"] = "1";
            // properties["shipping_interval_unit_type"] = "Months";
          }

          let currentWeekday = dayjs().day();
          if (currentWeekday >= 4) {
            let wednesdayThisWeek = dayjs().day(3);
            let NextChargeDate = wednesdayThisWeek.add(2, "week");
            let diffDays = NextChargeDate.diff(dayjs(), "day"); // 20214000000 default milliseconds
            console.log("wednesdayThisWeek :>> ", wednesdayThisWeek);
            console.log("currentWeekday :>> ", currentWeekday);
            console.log("diffDays :>> ", diffDays);
            properties["first_recurring_charge_delay"] = diffDays;
          }

          let selling_plans =
            this.customMainProduct.selling_plan_groups?.[0]?.selling_plans?.find(
              (e) => e.name.toLowerCase().includes(this.delivery_type)
            );
          let mainSellingPlanId = selling_plans?.id;
          if (this.delivery_type == "one-time") {
            properties = {};
            mainSellingPlanId = null;
          } else {
            if (!mainSellingPlanId) {
              alert("Selling Plan not found");
              return;
            }
          }
          let items = [
            {
              id: this.customMainProductVariant?.id,
              selling_plan: mainSellingPlanId,
              quantity: 1,
              properties: {
                "Ship Date": this.deliveryDate,
                "Meals Per Week": MAX_ALLOWED_SELECTION,
                ...properties,
              },
            },
          ];

          this.selected.forEach((i) => {
            let selling_planId =
              i.selling_plan_groups?.[0]?.selling_plans?.find((e) =>
                e.name.toLowerCase().includes(this.delivery_type)
              )?.id;
            if (this.delivery_type == "one-time") {
              selling_planId = null;
            } else {
              if (!selling_planId) {
                alert("Selling Plan not found");
                return;
              }
            }

            items.push({
              id: i.variants[0].id,
              selling_plan: selling_planId,
              quantity: i.quantity,
              properties,
            });
          });

          let data = {
            items,
          };

          console.log("DATA: ", data);

          await axios.post(`/cart/clear.js`, {});
          await axios.post(`/cart/add.js`, data);
          await axios.post(`/cart/update.js`, {
            attributes: {
              "Ship Date": this.deliveryDate,
            },
          });

          this.currentTab = "Checkout";
          this.grouped = _.groupBy(this.selected, (item) => item.id);
          console.log("GROUPED: ", this.grouped);
          axios.get(`/cart.js`).then((res) => {
            this.cartData = res.data;
          });
        } catch (e) {
          console.log("Error: ", e);
          let error = e?.response?.data?.description;
          if (!error) error = e.message;

          alert(error);
        } finally {
          this.cartProcessing = false;
        }
      },
      getDeliveryDate(selectedDeliveryDay) {
        dayjs.extend(dayjs_plugin_weekday);
        let todayDate = dayjs();
        if (todayDate.day() < 5) {
          todayDate = todayDate.add(1, "day");
        }
        let TodayDayOfweek = todayDate.day();
        let AllowedDays = [1]; //MONDAY NOW // Wednesday and Friday;
        let possibleDeliveryDay = TodayDayOfweek + 3;
        //    let selectedDeliveryDay = 5; //
        let StartNextWeek = false;
        if (possibleDeliveryDay > 5) {
          StartNextWeek = true;
        }
        let DeliveryDay;
        if (possibleDeliveryDay < selectedDeliveryDay) {
          DeliveryDay = dayjs().weekday(selectedDeliveryDay);
        } else if (TodayDayOfweek > 3) {
          DeliveryDay = dayjs().weekday(selectedDeliveryDay).add(2, "week");
        } else {
          DeliveryDay = dayjs().weekday(selectedDeliveryDay).add(1, "week");
        }

        return DeliveryDay;
      },
      checkout() {
        console.log(`CHECKING OUT...!`);
        let event = new Event("one_page_store_checkout", {
          bubbles: true,
        });
        if (this.delivery_type == "one-time") {
          location.href = "/checkout";
          _learnq.push(["track", "one-time-checkout"]);
        } else {
          document.dispatchEvent(event);
        }
      },
      getTypeTagIfAvailable(product) {
        let tags = product.tags;
        if (!product.tags) return null;
        if (!Array.isArray(tags)) return null;
        let typeTag = tags.find((tag) => tag.includes("type_"));
        if (typeTag) {
          return `<span >
              {typeTag.replace("type_", "")}
            </span>`;
        } else if (product.tags.includes("Breakfast")) {
          return `<span >
              Breakfast
            </span>`;
        }

        return null;
      },
    },
    computed: {
      delivery_type_text() {
        if (this.delivery_type == "1") {
          return "Every Week";
        } else if (this.delivery_type == "2") {
          return "Every Other Week";
        } else if (this.delivery_type == "4") {
          return "Every Month";
        }
        return "One Time";
      },
      totalQuantity() {
        return this.selected.reduce((acc, item) => acc + item.quantity, 0);
      },
      total() {
        return parseInt(this.how_many_meals);
      },
      customMainProductVariant() {
        let howManyMeals = this.total;
        let price = this.getParemeterByName("price");
        let source = this.product_type?.toLowerCase();
        let variant = this.customMainProduct.variants.find((i) => {
          return (
            i.option2.toLowerCase().includes(source) &&
            i.option1.includes(howManyMeals)
          );
        });

        return variant;
      },
      product_type() {
        let source = this.getParemeterByName("product_type");
        return source || "women_health";
      },
      customMainProduct() {
        if (this.oneTimeProduct && this.delivery_type == "one-time") {
          return this.oneTimeProduct;
        }
        return this.customData;
      },
      filteredProducts() {
        if (this.mealOptionsNew) {
          return this.products.filter((product) => {
            return this.mealOptionsNew.every((option) => {
              if (option.checked) {
                return product.tags.includes(option.value.toLowerCase());
              }
              return true;
            });
          });
        }
        return this.products;
      },
      productNotFound() {
        return this.filteredProducts.length === 0 && this.products.length > 0;
      },
      mealOptionsNew() {
        let options = this.mealOptions;
        options = options.map((option) => {
          option.count = this.products.filter((product) => {
            product.tags = product.tags.map((tag) => tag.toLowerCase());
            return product.tags.includes(option.value.toLowerCase());
          });
          option.count = option.count.length;
          return option;
        });

        return options;
      },
      selectedMealLabel() {
        const selectedOption = this.mealOptions.find(
          (option) => option.value === this.selectedmeal
        );
        return selectedOption ? selectedOption.label : "";
      },
      filteredProductCount() {
        return this.filteredProducts.length;
      },
      checkedOptions() {
        return this.mealOptions.filter((option) => option.checked);
      },
      checkedCount() {
        return this.mealOptions.filter((option) => option.checked).length;
      },
      sortingcheckedCount() {
        return this.sortingOptions.filter((option) => option.checked).length;
      },
      sortedMealOptions() {
        return this.mealOptionsNew.slice().sort((a, b) => b.count - a.count);
      },
    },
    mounted() {
      document.addEventListener("one_page_store_checkout", function (event) {
        _learnq.push(["track", "pick-your-own-completed"]);
        $(".cart__checkout").addClass("btn--body loading");
        //window.reChargeProcessCart();
        location.href = "/checkout";
        console.log("Checkout Event called.");
      });
    },
    components: {},
    created() {
      // store.getProducts();
      this.deliveryDate = this.getDeliveryDate(2);
      this.showingDeliveryDate = this.getDeliveryDate(2);
      axios
        .get(
          `/collections/heart-healthy?view=custom-collection-json`
        )
        .then((res) => {
          console.log(res);
          if (res.data && res.data.products) {
            this.products = res.data.products;
          }
        });

      axios
        .get(
          `/products/one-page-checkout?view=custom-meta`
        )
        .then((res) => {
          console.log("Custom DATA: ", res);
          this.customData = res.data.product;
        });
      axios
        .get(
          `/products/longevity-diet-pick-your-own-plan-one-time?view=custom-meta`
        )
        .then((res) => {
          console.log("Custom DATA: ", res);
          this.oneTimeProduct = res.data.product;
        });
    },
    watch: {
      totalQuantity(oldQuantity, newQuantity) {
        setTimeout(() => {
          let qty = this.totalQuantity;

          if (qty == this.total) {
            this.showSummary = true;
          }
        }, 100);
      },
    },
  }).mount("#meals-checkout-app");
}
